<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane name="settings" label="Settings">
      <site-map-config @update="updateTheme" :theme="org.colors">
      </site-map-config>
    </el-tab-pane>
    <el-tab-pane name="fees" label="Fee Types">
      <el-card shadow="never">
        <div slot="header">
          <el-button
            size="small"
            class="button"
            type="primary"
            icon="el-icon-plus"
            @click="() => dialogFeeTypeVisible = true"
            round>
            Add
          </el-button>
        </div>
        <el-table :data="org.feeTypes">
          <el-table-column label="Name"
          prop="name"></el-table-column>
          <el-table-column label="Description"
          prop="description"></el-table-column>
          <el-table-column label="Code"
          prop="code"></el-table-column>
        </el-table>
      </el-card>
      <el-dialog id="wait" :visible.sync="dialogFeeTypeVisible">
        <el-alert type="warning" title="Make sure the code matches with the fee types in lease line item. Ex: If Line Item fee type is Late Fee, fee type code will be LateFee">
        </el-alert>
        <el-form :model="feeTypeForm" :rules="rules" ref="form">
          <el-form-item
            label="Name"
            prop="name"
            :rules="[{ required: true, message: 'Please add name', trigger: 'blur'}]"
          >
            <el-input v-model="feeTypeForm.name"></el-input>
          </el-form-item>
          <el-form-item
            label="Code"
            prop="code"
          >
            <el-input v-model="feeTypeForm.code"></el-input>
          </el-form-item>
          <el-form-item
            label="Description"
            prop="description"
          >
            <el-input v-model="feeTypeForm.description"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="saveFeeTypes">Save</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-tab-pane>
    <!-- <el-tab-pane name="tax" label="Facility Tax">
      <FacilityTaxSettings :facility="facility" />
    </el-tab-pane> -->
    <!-- <el-tab-pane name="pricing" label="Pricing">
      <OrgPricing :pricing="org.pricing"/>
    </el-tab-pane> -->
    <!-- <el-tab-pane name="managers" label="Manager">
      <OrgPricing :pricing="org.pricing"/>
    </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import axios from 'axios';
import { ORG_API_UPDATE, ORG_API_FEE_TYPES } from '../env';
import SiteMapConfig from './SiteMapConfig.vue';

export default {
  components: { SiteMapConfig },
  props: {
    org: { type: Object },
    facility: { type: String, default: null },
  },
  data() {
    const checkForUniqueCode = (rule, value, callback) => {
      if (!value)
        return callback(new Error('Cannot be empty') );

      if (this.org.feeTypes.map(item => item.code).includes(value)) {
        return callback(new Error('Fee Type code should be unique'));
      }

      callback();
    };
    return {
      ready: false,
      rules: {
        code: [
          { validator: checkForUniqueCode, trigger: 'blur' }
        ]
      },
      activeTab: 'settings',
      taxFlag: false,
      dialogFeeTypeVisible: false,
      feeTypeForm: {
        name: '',
        description: '',
        code: ''
      },
    };
  },
  methods: {
    async updateTheme(theme) {
      const orgApi = `${ORG_API_UPDATE}`;
      try {
        await axios.put(`${orgApi}`, {
          colors: theme,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.$message({
          type: 'success',
          message: 'Update completed',
        });
        this.$emit('reload');
      } catch (err) {
        this.$message({
          type: 'error',
          message: err.response.data,
        });
      }
    },
    saveFeeTypes() {
      this.$refs.form.validate((valid, form) => console.log( valid, form));
      this.$refs.form.validate( async (valid) => {
        if (valid) {
          try {
            await axios.put(`${ORG_API_FEE_TYPES}`, {
              feeTypes: this.org.feeTypes ? [...this.org.feeTypes, this.feeTypeForm ] : [this.feeTypeForm],
            }, {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            });
            this.$message({
              type: 'success',
              message: 'Update completed',
            });
            this.feeTypeForm = {
              name: '',
              description: '',
              code: ''
            };
            this.dialogFeeTypeVisible = false;
            this.$emit('reload');
          } catch (err) {
            this.$message({
              type: 'error',
              message: err.response.data,
            });
          }
        }
      });
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrgConfig.vue